import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAwntlZ3RgMlJbt6928xALnp9rp_N1M8P0",
  authDomain: "benimingilizcekartlarim.firebaseapp.com",
  projectId: "benimingilizcekartlarim",
  storageBucket: "benimingilizcekartlarim.appspot.com",
  messagingSenderId: "49550914350",
  appId: "1:49550914350:web:919cb8c28f5d5c545a00bf"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
